import { Tab, Tabs, TabsProps, Tooltip } from '@mui/material';
import { HelpOutlineOutlined as HelpOutlineOutlinedIcon } from '@mui/icons-material';
import { TabsContainer, TabsContainerProps } from '../../../../../components/Tabs';
import Row from '../../../../../components/Row';

export const REPORTING_TAB_CONFIG = {
    'all-media': { tabIndex: 0, slug: 'all-media', label: 'All Media' },
    display: { tabIndex: 1, slug: 'display', label: 'Display' },
    'online-video': { tabIndex: 2, slug: 'online-video', label: 'Online Video' },
    'streaming-tv': { tabIndex: 3, slug: 'streaming-tv', label: 'Streaming TV' },
    audio: { tabIndex: 4, slug: 'audio', label: 'Audio' },
    video: { tabIndex: 5, slug: 'video', label: 'Video' },
} as const;

export type ReportingTabSlug = keyof typeof REPORTING_TAB_CONFIG;

export const DEFAULT_TAB_SLUG: ReportingTabSlug = 'all-media';

export function isReportingTabSlug(value: string): value is ReportingTabSlug {
    return value in REPORTING_TAB_CONFIG;
}

type ReportingMediaTabsProps = {
    slotProps?: {
        tabsContainer?: TabsContainerProps;
    };
} & TabsProps;

export default function ReportingMediaTabs(props: ReportingMediaTabsProps) {
    const { slotProps = {}, ...tabsProps } = props;

    return (
        <TabsContainer sx={{ mt: 2 }} {...slotProps?.tabsContainer}>
            <Tabs {...tabsProps}>
                <Tab
                    value={REPORTING_TAB_CONFIG['all-media'].tabIndex}
                    label={REPORTING_TAB_CONFIG['all-media'].label}
                />
                <Tab value={REPORTING_TAB_CONFIG['display'].tabIndex} label={REPORTING_TAB_CONFIG['display'].label} />
                <Tab
                    value={REPORTING_TAB_CONFIG['online-video'].tabIndex}
                    label={REPORTING_TAB_CONFIG['online-video'].label}
                />
                <Tab
                    value={REPORTING_TAB_CONFIG['streaming-tv'].tabIndex}
                    label={REPORTING_TAB_CONFIG['streaming-tv'].label}
                />
                <Tab value={REPORTING_TAB_CONFIG['audio'].tabIndex} label={REPORTING_TAB_CONFIG['audio'].label} />
                <Tab
                    value={REPORTING_TAB_CONFIG['video'].tabIndex}
                    label={
                        <Row gap={1} alignItems="center" width="auto">
                            {REPORTING_TAB_CONFIG['video'].label}
                            <Tooltip title="Video is a legacy media type that may contain a combination of one or many Online Video and or Streaming TV campaigns.">
                                <HelpOutlineOutlinedIcon color="action" sx={{ fontSize: 16 }} />
                            </Tooltip>
                        </Row>
                    }
                />
            </Tabs>
        </TabsContainer>
    );
}
